import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ParticleSystem } from "@/components/layout/ParticleSystem";
import { LogIn } from "lucide-react";

export const HeroSection = () => {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="h-[600px]">
      <div className="relative h-full overflow-hidden">
        <div className="absolute inset-0 bg-primary">
          <ParticleSystem />
        </div>
        <div className="relative z-10 pointer-events-none">
          {/* Header Section */}
          <div className="max-w-[2000px] mx-auto w-full h-[80px] flex items-center justify-between px-8">
            {/* Logo */}
            <img 
              src="/maia_logo_white.svg" 
              alt="Maia Logo"
              className="h-8 w-auto pointer-events-auto" 
            />
            
            {/* Centered Navigation Menu */}
            <nav className="hidden md:flex items-center space-x-12 absolute left-1/2 transform -translate-x-1/2 pointer-events-auto">
              <button 
                onClick={() => scrollToSection('features')} 
                className="text-white hover:text-white/80 transition-colors"
              >
                Features
              </button>
              <button 
                onClick={() => scrollToSection('human-loop')} 
                className="text-white hover:text-white/80 transition-colors"
              >
                Human in the Loop
              </button>
              <button 
                onClick={() => scrollToSection('tutorials')} 
                className="text-white hover:text-white/80 transition-colors"
              >
                Tutorials
              </button>
              <button 
                onClick={() => scrollToSection('privacy')} 
                className="text-white hover:text-white/80 transition-colors"
              >
                Privacy
              </button>
              <button 
                onClick={() => scrollToSection('pricing')} 
                className="text-white hover:text-white/80 transition-colors"
              >
                Pricing
              </button>
            </nav>

            {/* Sign In Button */}
            <Button 
              variant="secondary" 
              onClick={() => navigate('/login')}
              className="pointer-events-auto"
            >
              <LogIn className="h-4 w-4 mr-2" />
              Sign In
            </Button>
          </div>

          {/* Hero Content */}
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
            <img 
              src="/Maia_horizontal_color.svg"
              alt="Maia"
              className="h-16 md:h-20 mx-auto mb-8 pointer-events-auto"
            />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Supercharge your email productivity with Maia Email Assistant for Gmail
            </h1>
            <p className="text-xl md:text-2xl text-white/80 mb-8 max-w-3xl mx-auto">
              Handle your emails 5x faster with AI-powered responses while maintaining quality and consistency
            </p>
            <Button 
              size="lg" 
              onClick={() => navigate('/login')} 
              className="bg-white text-primary hover:bg-white/90 pointer-events-auto"
            >
              Get Started Free
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};